import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseDiscountDeletedTemplates = [
  {
    id: '-113001',
    language: Language.EN,
    subject: 'Lease discount interruption',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Dear {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerns: discount interruption on the lease located at <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>We regret to inform you we have prematurely discontinued the discount labeled: <strong>{{lvoLabel lvo language}}</strong>.</p>
        <p></p>
        <p>Kind regards,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-113002',
    language: Language.FR,
    subject: 'Interruption de remise sur bail',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Cher/Chère {{listAllTenants lease}},</p>
        <p></p>
        <p>Concerne: interruption de remise sur le bail sis <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Nous sommes au regret de vous informer avoir mis fin anticipativement à la remise portant le libellé: <strong>{{lvoLabel lvo language}}</strong>.</p>
        <p></p>
        <p>Bien à vous,</p>
        <p></p>
        <p>{{accountSignature client}}</p>`,
  },
  {
    id: '-113003',
    language: Language.NL,
    subject: 'Intrekking van een huurkorting',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Geachte {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreffende: intrekking van een korting op uw huurcontract gelegen te <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Tot onze spijt moeten wij u mededelen dat wij de korting met label "<strong>{{lvoLabel lvo language}}</strong>" opgezegd hebben.</p>
        <p></p>
        <p>Met vriendelijke groeten,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
  {
    id: '-113004',
    language: Language.DE,
    subject: 'Unterbrechung des Mietrabatts',
    type: TemplateType.MAIL,
    subType: TemplateSubType.LEASE_DISCOUNT_DELETED,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
        <p>Liebe/r {{listAllTenants lease}},</p>
        <p></p>
        <p>Betreff: Unterbrechung des Rabatts auf den Mietvertrag in <strong>{{getLeaseMainAddress lease}}</strong>.</p>
        <p></p>
        <p>Wir bedauern, Ihnen mitteilen zu müssen, dass wir den Rabatt mit der Bezeichnung "<strong>{{lvoLabel lvo language}}</strong>" vorzeitig beendet haben.</p>
        <p></p>
        <p>Mit freundlichen Grüßen,</p>
        <p></p>
        <p>{{accountSignature client}}</p>
        `,
  },
];
